module.exports = __webpack_public_path__ + "media/images/ibu__icon__mail-a8d5a46d6642c13d194c2b7ad973a7eb.svg";